var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.141,
    height: 56.141,
    viewBox: "0 0 56.141 56.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38816",
    "data-name": "Rectangle 38816",
    width: 26.348,
    height: 18.796,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_164384",
    "data-name": "Group 164384",
    transform: "translate(-707.502 -257.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_10",
    "data-name": "Exclusion 10",
    d: "M20941.221-16862.348a27.57,27.57,0,0,1,27.57,27.57,27.57,27.57,0,0,1-27.57,27.57,27.57,27.57,0,0,1-27.57-27.57A27.57,27.57,0,0,1,20941.221-16862.348Z",
    transform: "translate(-20205.648 17120.348)",
    fill: "#7cd0ff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_164375",
    "data-name": "Group 164375",
    transform: "translate(722.398 275.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164374",
    "data-name": "Group 164374",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277988",
    "data-name": "Path 277988",
    d: "M38.664,0Q44.332,0,50,0a1.927,1.927,0,0,1,1.083.32c.086.056.088.085.008.153Q49.377,1.94,47.667,3.413q-4.461,3.832-8.919,7.667c-.085.073-.126.041-.19-.014Q35.693,8.6,32.826,6.139L26.252.492c-.119-.1-.12-.1.012-.19A1.879,1.879,0,0,1,27.314,0q5.675,0,11.35,0",
    transform: "translate(-25.489 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277989",
    "data-name": "Path 277989",
    d: "M38.721,414.879q-5.675,0-11.35,0a1.787,1.787,0,0,1-1.073-.345c-.09-.065-.083-.1,0-.166q1.857-1.588,3.71-3.181,2.647-2.272,5.293-4.545c.091-.078.142-.09.239,0,1.024.9,2.054,1.792,3.078,2.69.086.076.135.074.22,0,1.031-.9,2.067-1.8,3.1-2.707.074-.065.115-.065.19,0q4.515,3.878,9.035,7.749c.081.069.084.1,0,.165a1.8,1.8,0,0,1-1.086.346q-4.224,0-8.448,0h-2.9",
    transform: "translate(-25.556 -396.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277990",
    "data-name": "Path 277990",
    d: "M688.542,71.811v15.2c-.056.017-.078-.03-.107-.055q-3.389-2.892-6.777-5.786c-.621-.53-1.241-1.063-1.865-1.59-.084-.071-.089-.1,0-.178q3.24-2.818,6.476-5.642l2.159-1.88c.031-.027.055-.066.117-.071",
    transform: "translate(-662.194 -69.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277991",
    "data-name": "Path 277991",
    d: "M0,87.091v-15.2c.062,0,.091.049.127.081l7.844,6.839c.259.226.517.453.779.677.067.057.092.087.006.16Q4.425,83.337.1,87.037c-.025.021-.045.053-.1.053",
    transform: "translate(0 -70.032)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.efa9120e22e39cabdaea7f580caff23e.svg";
export { ForwardRef as ReactComponent };